/*
 * DRIVLY-UI React Components
 * @license MIT
 */
import{useEffect as e}from"react";import{useCallbackRef as o}from"../../react-use-callback-ref/dist/index.js";function s(s,n=(null===globalThis||void 0===globalThis?void 0:globalThis.document)){const t=o(s);e((()=>{const e=e=>{"Escape"===e.key&&t(e)};return n.addEventListener("keydown",e),()=>n.removeEventListener("keydown",e)}),[t,n])}export{s as useEscapeKeydown};
//# sourceMappingURL=index.js.map
